var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main" },
    [
      _c(
        "b-card",
        [
          _c(
            "b-card-body",
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    {
                      staticClass: "d-flex justify-content-end",
                      attrs: { md: "12" },
                    },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "mr-2",
                          attrs: { variant: "outline-success" },
                          on: { click: _vm.exportToCSV },
                        },
                        [
                          _c("feather-icon", {
                            staticClass: "mr-50",
                            attrs: { icon: "DownloadIcon" },
                          }),
                          _vm._v(" Export CSV "),
                        ],
                        1
                      ),
                      _c(
                        "b-button",
                        {
                          directives: [
                            {
                              name: "b-modal",
                              rawName: "v-b-modal.modal-add-performance",
                              modifiers: { "modal-add-performance": true },
                            },
                          ],
                          attrs: { variant: "primary" },
                        },
                        [
                          _c("feather-icon", {
                            staticClass: "mr-50",
                            attrs: { icon: "PlusIcon" },
                          }),
                          _vm._v(" Add New "),
                        ],
                        1
                      ),
                      _c(
                        "b-modal",
                        {
                          ref: "addPerformance",
                          attrs: {
                            id: "modal-add-performance",
                            "ok-only": "",
                            "ok-title": "Add",
                            centered: "",
                            size: "lg",
                            title: "Add Reward",
                            "hide-footer": true,
                          },
                        },
                        [
                          _c("AddPerformance", {
                            on: { PerformaceAdded: _vm.closeAddModal },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { staticClass: "my-1", attrs: { md: "2", sm: "4" } },
                    [
                      _c(
                        "b-form-group",
                        { staticClass: "mb-0" },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "d-inline-block text-sm-left mr-50",
                            },
                            [_vm._v("Per page")]
                          ),
                          _c("b-form-select", {
                            staticClass: "w-50",
                            attrs: {
                              id: "perPageSelect",
                              size: "sm",
                              options: _vm.pageOptions,
                            },
                            model: {
                              value: _vm.perPage,
                              callback: function ($$v) {
                                _vm.perPage = $$v
                              },
                              expression: "perPage",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    {
                      staticClass: "d-flex justify-content-end mb-2",
                      staticStyle: { position: "relative", "z-index": "1" },
                      attrs: { cols: "12" },
                    },
                    [
                      _c(
                        "b-button",
                        {
                          attrs: { variant: "outline-danger", size: "sm" },
                          on: { click: _vm.clearFilters },
                        },
                        [_vm._v(" Clear Filters ")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("b-table", {
                        attrs: {
                          striped: "",
                          hover: "",
                          responsive: "",
                          "per-page": _vm.perPage,
                          "current-page": _vm.currentPage,
                          items: _vm.filteredPerformanceRecords,
                          fields: _vm.performance_fields,
                          "sort-by": _vm.sortBy,
                          "sort-desc": _vm.sortDesc,
                          "sort-direction": _vm.sortDirection,
                        },
                        on: {
                          "update:sortBy": function ($event) {
                            _vm.sortBy = $event
                          },
                          "update:sort-by": function ($event) {
                            _vm.sortBy = $event
                          },
                          "update:sortDesc": function ($event) {
                            _vm.sortDesc = $event
                          },
                          "update:sort-desc": function ($event) {
                            _vm.sortDesc = $event
                          },
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "head(awardTitle)",
                            fn: function (scope) {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "d-flex flex-column" },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticStyle: { cursor: "pointer" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.toggleSort("awardTitle")
                                          },
                                        },
                                      },
                                      [_vm._v("Reward Title")]
                                    ),
                                    _c("b-form-input", {
                                      attrs: {
                                        placeholder: "Filter by Reward Title",
                                        size: "sm",
                                      },
                                      on: { input: _vm.applyFilters },
                                      model: {
                                        value: _vm.filters.awardTitle,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.filters,
                                            "awardTitle",
                                            $$v
                                          )
                                        },
                                        expression: "filters.awardTitle",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                          {
                            key: "head(employeeId)",
                            fn: function (scope) {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "d-flex flex-column" },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticStyle: { cursor: "pointer" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.toggleSort(
                                              "employeeName"
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("Employee")]
                                    ),
                                    _c("b-form-input", {
                                      attrs: {
                                        placeholder: "Filter by Employee",
                                        size: "sm",
                                      },
                                      on: { input: _vm.applyFilters },
                                      model: {
                                        value: _vm.filters.employeeName,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.filters,
                                            "employeeName",
                                            $$v
                                          )
                                        },
                                        expression: "filters.employeeName",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                          {
                            key: "head(gift)",
                            fn: function (scope) {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "d-flex flex-column" },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticStyle: { cursor: "pointer" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.toggleSort("gift")
                                          },
                                        },
                                      },
                                      [_vm._v("Gift")]
                                    ),
                                    _c("b-form-input", {
                                      attrs: {
                                        placeholder: "Filter by Gift",
                                        size: "sm",
                                      },
                                      on: { input: _vm.applyFilters },
                                      model: {
                                        value: _vm.filters.gift,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.filters, "gift", $$v)
                                        },
                                        expression: "filters.gift",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                          {
                            key: "head(price)",
                            fn: function (scope) {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "d-flex flex-column" },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticStyle: { cursor: "pointer" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.toggleSort("price")
                                          },
                                        },
                                      },
                                      [_vm._v("Price")]
                                    ),
                                    _c("b-form-input", {
                                      attrs: {
                                        placeholder: "Filter by Price",
                                        type: "number",
                                        size: "sm",
                                      },
                                      on: { input: _vm.applyFilters },
                                      model: {
                                        value: _vm.filters.price,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.filters, "price", $$v)
                                        },
                                        expression: "filters.price",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                          {
                            key: "head(date)",
                            fn: function (scope) {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "d-flex flex-column" },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticStyle: { cursor: "pointer" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.toggleSort("date")
                                          },
                                        },
                                      },
                                      [_vm._v("Date")]
                                    ),
                                    _c("DatePicker", {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        range: "",
                                        format: "YYYY-MM-DD",
                                        placeholder: "Select date range",
                                      },
                                      on: { change: _vm.applyFilters },
                                      model: {
                                        value: _vm.filters.dateRange,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.filters,
                                            "dateRange",
                                            $$v
                                          )
                                        },
                                        expression: "filters.dateRange",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                          {
                            key: "cell(employeeId)",
                            fn: function (data) {
                              return [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.getEmployeeName(data.item.employeeId)
                                    ) +
                                    " "
                                ),
                              ]
                            },
                          },
                          {
                            key: "cell(date)",
                            fn: function (data) {
                              return [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.formatDate(data.item.date)) +
                                    " "
                                ),
                              ]
                            },
                          },
                          {
                            key: "cell(status)",
                            fn: function (data) {
                              return [
                                _c(
                                  "b-badge",
                                  {
                                    attrs: {
                                      variant: _vm.status[1][data.value],
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.status[0][data.value]) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                          {
                            key: "cell(actions)",
                            fn: function (data) {
                              return [
                                _c(
                                  "b-dropdown",
                                  {
                                    staticClass: "m-1",
                                    attrs: {
                                      variant: "link",
                                      "toggle-class": "p-0",
                                      "no-caret": "",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "button-content",
                                          fn: function () {
                                            return [
                                              _c("feather-icon", {
                                                staticClass:
                                                  "align-middle text-body",
                                                attrs: {
                                                  icon: "MoreVerticalIcon",
                                                  size: "16",
                                                },
                                              }),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  },
                                  [
                                    _c(
                                      "b-dropdown-item",
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.editPerformance(
                                              data.item
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("feather-icon", {
                                          attrs: { icon: "EditIcon" },
                                        }),
                                        _c(
                                          "span",
                                          { staticClass: "align-middle ml-50" },
                                          [_vm._v("Edit")]
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "b-dropdown-item",
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.removePerformanceRecord(
                                              data.item.performanceRecordId
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("feather-icon", {
                                          attrs: { icon: "TrashIcon" },
                                        }),
                                        _c(
                                          "span",
                                          { staticClass: "align-middle ml-50" },
                                          [_vm._v("Delete")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-modal",
                    {
                      ref: "editPerformance",
                      attrs: {
                        id: "modal-edit-performance",
                        "ok-only": "",
                        "ok-title": "Edit",
                        centered: "",
                        size: "lg",
                        title: "Edit Reward",
                        "hide-footer": true,
                      },
                    },
                    [
                      _c("validation-observer", {
                        ref: "formEditPerformance",
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (ref) {
                              var invalid = ref.invalid
                              return [
                                _c(
                                  "b-form",
                                  {
                                    on: {
                                      submit: function ($event) {
                                        $event.preventDefault()
                                        return _vm.saveEditedPerformance($event)
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "b-row",
                                      [
                                        _c(
                                          "b-col",
                                          { attrs: { md: "12" } },
                                          [
                                            _c(
                                              "b-form-group",
                                              {
                                                attrs: {
                                                  label: "Reward Title",
                                                  "label-for": "awardTitle",
                                                },
                                              },
                                              [
                                                _c("validation-provider", {
                                                  attrs: {
                                                    rules: "required",
                                                    name: "Reward Title",
                                                    vid: "awardTitle",
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function (ref) {
                                                          var errors =
                                                            ref.errors
                                                          return [
                                                            _c("b-form-input", {
                                                              attrs: {
                                                                name: "awardTitle",
                                                                placeholder:
                                                                  "Reward Title",
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .editFormData
                                                                    .awardTitle,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.editFormData,
                                                                      "awardTitle",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "editFormData.awardTitle",
                                                              },
                                                            }),
                                                            _c(
                                                              "small",
                                                              {
                                                                staticClass:
                                                                  "text-danger",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    errors[0]
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "b-col",
                                          { attrs: { sm: "12" } },
                                          [
                                            _c(
                                              "b-form-group",
                                              {
                                                attrs: {
                                                  label: "Employee",
                                                  "label-for": "employee",
                                                },
                                              },
                                              [
                                                _c("b-form-select", {
                                                  attrs: {
                                                    options:
                                                      _vm.employeeOptions,
                                                    disabled: "",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.editFormData
                                                        .employeeId,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.editFormData,
                                                        "employeeId",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "editFormData.employeeId",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "b-col",
                                          { attrs: { md: "12" } },
                                          [
                                            _c(
                                              "b-form-group",
                                              {
                                                attrs: {
                                                  label: "Price",
                                                  "label-for": "price",
                                                },
                                              },
                                              [
                                                _c("b-form-input", {
                                                  attrs: {
                                                    name: "price",
                                                    placeholder: "Price",
                                                    type: "number",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.editFormData.price,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.editFormData,
                                                        "price",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "editFormData.price",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "b-col",
                                          { attrs: { md: "12" } },
                                          [
                                            _c(
                                              "b-form-group",
                                              {
                                                attrs: {
                                                  label: "Gift",
                                                  "label-for": "gift",
                                                },
                                              },
                                              [
                                                _c("b-form-input", {
                                                  attrs: {
                                                    name: "gift",
                                                    placeholder: "Gift",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.editFormData.gift,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.editFormData,
                                                        "gift",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "editFormData.gift",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "b-col",
                                          { attrs: { md: "12" } },
                                          [
                                            _c(
                                              "b-form-group",
                                              {
                                                attrs: {
                                                  label: "Date",
                                                  "label-for": "date",
                                                },
                                              },
                                              [
                                                _c("validation-provider", {
                                                  attrs: {
                                                    rules: "required",
                                                    name: "Date",
                                                    vid: "date",
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function (ref) {
                                                          var errors =
                                                            ref.errors
                                                          return [
                                                            _c(
                                                              "b-form-datepicker",
                                                              {
                                                                attrs: {
                                                                  id: "date",
                                                                  placeholder:
                                                                    "Start Date",
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm
                                                                      .editFormData
                                                                      .date,
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        _vm.editFormData,
                                                                        "date",
                                                                        $$v
                                                                      )
                                                                    },
                                                                  expression:
                                                                    "editFormData.date",
                                                                },
                                                              }
                                                            ),
                                                            _c(
                                                              "small",
                                                              {
                                                                staticClass:
                                                                  "text-danger",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    errors[0]
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "b-col",
                                          {
                                            staticClass:
                                              "d-flex justify-content-end",
                                            attrs: { md: "12" },
                                          },
                                          [
                                            _c(
                                              "b-button",
                                              {
                                                staticClass: "mr-2",
                                                attrs: {
                                                  type: "submit",
                                                  variant: "primary",
                                                },
                                                on: {
                                                  click:
                                                    _vm.saveEditedPerformance,
                                                },
                                              },
                                              [_vm._v(" Save ")]
                                            ),
                                            _c(
                                              "b-button",
                                              {
                                                attrs: { variant: "primary" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.$bvModal.hide(
                                                      "modal-edit-performance"
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("Cancel")]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("b-pagination", {
                        staticClass: "my-0",
                        attrs: {
                          "total-rows": _vm.totalRows,
                          "per-page": _vm.perPage,
                          align: "center",
                          size: "sm",
                        },
                        model: {
                          value: _vm.currentPage,
                          callback: function ($$v) {
                            _vm.currentPage = $$v
                          },
                          expression: "currentPage",
                        },
                      }),
                      _c("b-form-group", [
                        _vm._v(
                          " Showing " +
                            _vm._s(
                              _vm.totalRows > 0
                                ? _vm.perPage * (_vm.currentPage - 1) + 1
                                : 0
                            ) +
                            " to " +
                            _vm._s(
                              _vm.totalRows > 0
                                ? Math.min(
                                    _vm.perPage * _vm.currentPage,
                                    _vm.totalRows
                                  )
                                : 0
                            ) +
                            " of " +
                            _vm._s(_vm.totalRows > 0 ? _vm.totalRows : 0) +
                            " entries "
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }